var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container role-detail-box" }, [
    _c(
      "div",
      { staticClass: "common-header" },
      [
        _c("common-header", {
          attrs: {
            headerList: [
              { label: "系统管理", url: "" },
              { label: "角色管理", url: "/system/role" },
              { label: "角色信息", url: "" }
            ]
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                staticClass: "red_tabs",
                attrs: { label: "角色基本信息", name: "BASIC" }
              },
              [
                _c("div", { staticClass: "basic-info" }, [
                  _c(
                    "div",
                    { staticClass: "main" },
                    [
                      _c(
                        "div",
                        { staticClass: "basic-top" },
                        [
                          _c(
                            "el-row",
                            { staticClass: "row" },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _vm._v(
                                    "角色编号：" +
                                      _vm._s(_vm.roleBasicInfo.roleId)
                                  )
                                ])
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _vm._v(
                                    "系统名称：" +
                                      _vm._s(_vm.roleBasicInfo.systemName)
                                  )
                                ])
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(
                                  " 角色名称：" +
                                    _vm._s(_vm.roleBasicInfo.roleName) +
                                    " "
                                )
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                !!_vm.roleBasicInfo.roleType
                                  ? _c("div", [
                                      _vm._v(
                                        "角色类型：" +
                                          _vm._s(
                                            _vm.roleBasicInfo.roleType.value
                                          )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { staticClass: "row" },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                !!_vm.roleBasicInfo.roleStatus
                                  ? _c("div", [
                                      _vm._v(
                                        "角色状态：" +
                                          _vm._s(
                                            _vm.roleBasicInfo.roleStatus.value
                                          )
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _c("el-col", { attrs: { span: 18 } }, [
                                _c("div", [
                                  _vm._v(
                                    "角色说明：" +
                                      _vm._s(_vm.roleBasicInfo.roleDescription)
                                  )
                                ])
                              ])
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { staticClass: "row" },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _vm._v(
                                  " 是否设定管辖部门：" +
                                    _vm._s(
                                      _vm._f("filterNumberType")(
                                        _vm.roleBasicInfo.canSetManageOrg
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _vm._v(
                                    " 是否开启条线选择：" +
                                      _vm._s(
                                        _vm._f("filterNumberType")(
                                          _vm.roleBasicInfo.canSetBizLine
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ]),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", [
                                  _vm._v(
                                    " 是否可以动态计算人员辖区：" +
                                      _vm._s(
                                        _vm._f("filterNumberType")(
                                          _vm.roleBasicInfo.autoComputeArea
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-divider"),
                      _c(
                        "div",
                        {
                          staticClass: "basic-bottom",
                          style: {
                            "min-height":
                              _vm.screenHeight > 800
                                ? "calc(100vh - 312px)"
                                : "calc(100vh - 270px)"
                          }
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("角色权限列表")]
                            ),
                            _c("input", {
                              staticClass: "btn btn-red export-btn",
                              attrs: { type: "button", value: "导出" },
                              on: {
                                click: function($event) {
                                  return _vm.exportAll()
                                }
                              }
                            })
                          ]),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.permissionTableLoading,
                                  expression: "permissionTableLoading"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.rolePermissionData,
                                height:
                                  _vm.screenHeight > 800
                                    ? "calc(100vh - 453px)"
                                    : "calc(100vh - 433px)",
                                border: "",
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "permissionId",
                                  label: "权限编码",
                                  width: "250",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "permissionName",
                                  label: "权限名称",
                                  width: "250",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "permissionDesc",
                                  label: "权限描述",
                                  width: "680",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "updatedTime",
                                  label: "最后更新时间",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "updatedBy",
                                  label: "最后更新人",
                                  "show-overflow-tooltip": ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "footer-page" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.rolePermissionPagination.total,
                          "current-page": _vm.rolePermissionPagination.pageNum,
                          "page-sizes": [10, 20, 50, 100, 1000, 2000],
                          "page-size": _vm.rolePermissionPagination.pageSize,
                          "hide-on-single-page": false
                        },
                        on: {
                          "update:currentPage": function($event) {
                            return _vm.$set(
                              _vm.rolePermissionPagination,
                              "pageNum",
                              $event
                            )
                          },
                          "update:current-page": function($event) {
                            return _vm.$set(
                              _vm.rolePermissionPagination,
                              "pageNum",
                              $event
                            )
                          },
                          "current-change": _vm.rolePermissionCurrentChange,
                          "size-change": _vm.rolePermissionSizeChange
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            ),
            _c("el-tab-pane", { attrs: { label: "用户列表", name: "USERS" } }, [
              _c("div", { staticClass: "users" }, [
                _c(
                  "div",
                  { staticClass: "main" },
                  [
                    _c(
                      "div",
                      { staticClass: "users-top" },
                      [
                        _c(
                          "el-row",
                          { staticClass: "row" },
                          [
                            _c("el-col", { attrs: { span: 6 } }, [
                              _c("div", [
                                _vm._v(
                                  "角色编号：" +
                                    _vm._s(_vm.roleBasicInfo.roleId)
                                )
                              ])
                            ]),
                            _c("el-col", { attrs: { span: 6 } }, [
                              _c("div", [
                                _vm._v(
                                  "系统名称：" +
                                    _vm._s(_vm.roleBasicInfo.systemName)
                                )
                              ])
                            ]),
                            _c("el-col", { attrs: { span: 6 } }, [
                              _vm._v(
                                " 角色名称：" +
                                  _vm._s(_vm.roleBasicInfo.roleName) +
                                  " "
                              )
                            ]),
                            _c("el-col", { attrs: { span: 6 } }, [
                              !!_vm.roleBasicInfo.roleType
                                ? _c("div", [
                                    _vm._v(
                                      "角色类型：" +
                                        _vm._s(_vm.roleBasicInfo.roleType.value)
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "row" },
                          [
                            _c("el-col", { attrs: { span: 6 } }, [
                              !!_vm.roleBasicInfo.roleStatus
                                ? _c("div", [
                                    _vm._v(
                                      "角色状态：" +
                                        _vm._s(
                                          _vm.roleBasicInfo.roleStatus.value
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _c("el-col", { attrs: { span: 18 } }, [
                              _c("div", [
                                _vm._v(
                                  "角色说明：" +
                                    _vm._s(_vm.roleBasicInfo.roleDescription)
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "row" },
                          [
                            _c("el-col", { attrs: { span: 6 } }, [
                              _vm._v(
                                " 是否设定管辖部门：" +
                                  _vm._s(
                                    _vm._f("filterNumberType")(
                                      _vm.roleBasicInfo.canSetManageOrg
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("el-col", { attrs: { span: 6 } }, [
                              _c("div", [
                                _vm._v(
                                  " 是否开启条线选择：" +
                                    _vm._s(
                                      _vm._f("filterNumberType")(
                                        _vm.roleBasicInfo.canSetBizLine
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("el-col", { attrs: { span: 6 } }, [
                              _c("div", [
                                _vm._v(
                                  " 是否可以动态计算人员辖区：" +
                                    _vm._s(
                                      _vm._f("filterNumberType")(
                                        _vm.roleBasicInfo.autoComputeArea
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("el-divider")
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sub-tabs" },
                  [
                    _c(
                      "el-tabs",
                      {
                        on: { "tab-click": _vm.handleSubTabClick },
                        model: {
                          value: _vm.activeUserTabName,
                          callback: function($$v) {
                            _vm.activeUserTabName = $$v
                          },
                          expression: "activeUserTabName"
                        }
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "固定用户列表", name: "REGULAR" } },
                          [
                            _c(
                              "div",
                              { staticClass: "user-container" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "btns-group",
                                    staticStyle: {
                                      "justify-content": "flex-end"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        ref: "customized-filter-popover",
                                        attrs: {
                                          placement: "bottom",
                                          width: "280",
                                          trigger: "click",
                                          "popper-class": "filter-popover"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-form",
                                          {
                                            ref: "customizedFilterForm",
                                            staticClass: "customizedFilterForm",
                                            attrs: {
                                              model: _vm.customizedFilterForm,
                                              "label-width": "80px",
                                              "label-position": "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "用户名称" } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      filterable: "",
                                                      remote: "",
                                                      "collapse-tags": "",
                                                      "reserve-keyword": "",
                                                      placeholder:
                                                        "请输入用户ID或名称",
                                                      "remote-method":
                                                        _vm.userRemoteMethod,
                                                      loading:
                                                        _vm.userOptionLoading,
                                                      size: "small",
                                                      multiple: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.customizedFilterForm
                                                          .userId,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customizedFilterForm,
                                                          "userId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customizedFilterForm.userId"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.userOptions,
                                                    function(item) {
                                                      return _c("el-option", {
                                                        key: item.userId,
                                                        attrs: {
                                                          label:
                                                            item.userName +
                                                            "/" +
                                                            item.userId,
                                                          value: item.userId
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "所属机构" } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      multiple: "",
                                                      "collapse-tags": "",
                                                      placeholder:
                                                        "请选择所属机构"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.customizedFilterForm
                                                          .orgMap,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customizedFilterForm,
                                                          "orgMap",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customizedFilterForm.orgMap"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.customizedUserFilterData
                                                      .orgMap,
                                                    function(item) {
                                                      return _c("el-option", {
                                                        key: item.key,
                                                        attrs: {
                                                          label: item.value,
                                                          value: item.key
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm.roleBasicInfo
                                              .canSetManageOrg === 1
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: { label: "管辖部门" }
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          multiple: "",
                                                          "collapse-tags": "",
                                                          placeholder:
                                                            "请选择管辖部门"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .customizedFilterForm
                                                              .manageOrgMap,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.customizedFilterForm,
                                                              "manageOrgMap",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "customizedFilterForm.manageOrgMap"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm
                                                          .customizedUserFilterData
                                                          .manageOrgMap,
                                                        function(item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.key,
                                                              attrs: {
                                                                label:
                                                                  item.value,
                                                                value: item.key
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.roleBasicInfo.canSetBizLine ===
                                            1
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: { label: "管辖条线" }
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          multiple: "",
                                                          "collapse-tags": "",
                                                          placeholder:
                                                            "请选择管辖条线"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .customizedFilterForm
                                                              .bizLineList,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.customizedFilterForm,
                                                              "bizLineList",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "customizedFilterForm.bizLineList"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm
                                                          .customizedUserFilterData
                                                          .bizLineList,
                                                        function(item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.key,
                                                              attrs: {
                                                                label:
                                                                  item.value,
                                                                value: item.key
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "center"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "cancelBtn cancelOrRestBtnHover",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.resetFilterConfirm()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("重置")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "confirmBtn",
                                                    staticStyle: {
                                                      "margin-left": "16px",
                                                      width: "50px",
                                                      "min-width": "50px",
                                                      height: "24px",
                                                      padding: "0px",
                                                      "font-size": "12px",
                                                      border: "none",
                                                      "text-align": "center"
                                                    },
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.filterConfirm(
                                                          "customizedUser"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("确定")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("input", {
                                          staticClass: "btn btn-red filter-btn",
                                          attrs: {
                                            slot: "reference",
                                            type: "button",
                                            value: "筛选"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getUserFilterData(
                                                "customizedUser"
                                              )
                                            }
                                          },
                                          slot: "reference"
                                        })
                                      ],
                                      1
                                    ),
                                    _c("input", {
                                      staticClass: "btn btn-red export-btn",
                                      attrs: { type: "button", value: "导出" },
                                      on: {
                                        click: function($event) {
                                          return _vm.exportTable("customized")
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.customizedUsers,
                                      height:
                                        _vm.screenHeight > 800
                                          ? "calc(100vh - 488px)"
                                          : "calc(100vh - 478px)",
                                      border: "",
                                      "tooltip-effect": "dark"
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "userIdAndName",
                                        label: "用户",
                                        width: "200",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "mngLevel",
                                        label: "职级",
                                        width: "200",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "jobNameList",
                                        label: "职位",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _c(
                                      "el-table-column",
                                      {
                                        attrs: {
                                          prop: "corner",
                                          "show-overflow-tooltip": ""
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      effect: "dark",
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("div", {
                                                      attrs: {
                                                        slot: "content"
                                                      },
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.ToBreak(
                                                            scope.row.corner +
                                                              "角"
                                                          )
                                                        )
                                                      },
                                                      slot: "content"
                                                    }),
                                                    _c(
                                                      "div",
                                                      { staticClass: "line" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.corner
                                                          ) + "角"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      },
                                      [
                                        _c("template", { slot: "header" }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "header-ellipsis font14"
                                            },
                                            [_vm._v("AB角")]
                                          )
                                        ])
                                      ],
                                      2
                                    ),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "pathName",
                                        label: "所属机构",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _vm.roleBasicInfo.canSetManageOrg === 1
                                      ? _c("el-table-column", {
                                          attrs: {
                                            prop: "manageOrgNames",
                                            label: "管辖部门",
                                            "show-overflow-tooltip": ""
                                          }
                                        })
                                      : _vm._e(),
                                    _vm.roleBasicInfo.canSetBizLine === 1
                                      ? _c("el-table-column", {
                                          attrs: {
                                            prop: "bizLineNames",
                                            label: "管辖条线",
                                            "show-overflow-tooltip": ""
                                          }
                                        })
                                      : _vm._e(),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "createdTime",
                                        label: "创建时间",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "createdBy",
                                        label: "创建人",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "updatedTime",
                                        label: "最后更新时间",
                                        "show-overflow-tooltip": ""
                                      }
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "updatedBy",
                                        label: "最后更新人",
                                        "show-overflow-tooltip": ""
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "footer-page" },
                                  [
                                    _c("el-pagination", {
                                      attrs: {
                                        background: "",
                                        layout:
                                          "total, sizes, prev, pager, next, jumper",
                                        total: _vm.customizedPagination.total,
                                        "current-page":
                                          _vm.customizedPagination.pageNum,
                                        "page-sizes": [
                                          10,
                                          20,
                                          50,
                                          100,
                                          1000,
                                          2000
                                        ],
                                        "page-size":
                                          _vm.customizedPagination.pageSize,
                                        "hide-on-single-page": false
                                      },
                                      on: {
                                        "update:currentPage": function($event) {
                                          return _vm.$set(
                                            _vm.customizedPagination,
                                            "pageNum",
                                            $event
                                          )
                                        },
                                        "update:current-page": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.customizedPagination,
                                            "pageNum",
                                            $event
                                          )
                                        },
                                        "current-change":
                                          _vm.customizedCurrentChange,
                                        "size-change": _vm.customizedSizeChange
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm.roleBasicInfo.autoComputeArea === 1
                          ? _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "动态人员列表",
                                  name: "DYNAMIC"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "user-container" },
                                  [
                                    _c("div", { staticClass: "btns-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "btns-group-left" },
                                        [
                                          _vm._v(
                                            " 筛选人员规则：" +
                                              _vm._s(
                                                _vm.roleBasicInfo
                                                  .userLabelRuleName
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "btns-group-right" },
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              ref: "dynamic-filter-popover",
                                              attrs: {
                                                placement: "bottom",
                                                width: "280",
                                                trigger: "click",
                                                "popper-class": "filter-popover"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-form",
                                                {
                                                  ref: "dynamicFilterForm",
                                                  staticClass:
                                                    "customizedFilterForm",
                                                  attrs: {
                                                    model:
                                                      _vm.dynamicFilterForm,
                                                    "label-width": "80px",
                                                    "label-position": "top"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "用户名称"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            filterable: "",
                                                            remote: "",
                                                            "reserve-keyword":
                                                              "",
                                                            placeholder:
                                                              "请输入用户ID或名称",
                                                            "remote-method":
                                                              _vm.userRemoteMethod,
                                                            loading:
                                                              _vm.userOptionLoading,
                                                            size: "small",
                                                            multiple: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .dynamicFilterForm
                                                                .userId,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.dynamicFilterForm,
                                                                "userId",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "dynamicFilterForm.userId"
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.userOptions,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key:
                                                                  item.userId,
                                                                attrs: {
                                                                  label:
                                                                    item.userName +
                                                                    "/" +
                                                                    item.userId,
                                                                  value:
                                                                    item.userId
                                                                }
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "所属机构"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            multiple: "",
                                                            placeholder:
                                                              "请选择所属机构"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .dynamicFilterForm
                                                                .orgMap,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.dynamicFilterForm,
                                                                "orgMap",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "dynamicFilterForm.orgMap"
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.autoUserFilterData
                                                            .orgMap,
                                                          function(item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.key,
                                                                attrs: {
                                                                  label:
                                                                    item.value,
                                                                  value:
                                                                    item.key
                                                                }
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm.roleBasicInfo
                                                    .canSetManageOrg === 1
                                                    ? _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "管辖部门"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              attrs: {
                                                                multiple: "",
                                                                placeholder:
                                                                  "请选择管辖部门"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .dynamicFilterForm
                                                                    .manageOrgMap,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.dynamicFilterForm,
                                                                    "manageOrgMap",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "dynamicFilterForm.manageOrgMap"
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm
                                                                .autoUserFilterData
                                                                .manageOrgMap,
                                                              function(item) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key:
                                                                      item.key,
                                                                    attrs: {
                                                                      label:
                                                                        item.value,
                                                                      value:
                                                                        item.key
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.roleBasicInfo
                                                    .canSetBizLine === 1
                                                    ? _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "管辖条线"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              attrs: {
                                                                multiple: "",
                                                                placeholder:
                                                                  "请选择管辖条线"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .dynamicFilterForm
                                                                    .bizLineList,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.dynamicFilterForm,
                                                                    "bizLineList",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "dynamicFilterForm.bizLineList"
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm
                                                                .autoUserFilterData
                                                                .bizLineList,
                                                              function(item) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key:
                                                                      item.key,
                                                                    attrs: {
                                                                      label:
                                                                        item.value,
                                                                      value:
                                                                        item.key
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "cancelBtn",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.resetFilterConfirm()
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("重置")]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "16px",
                                                            width: "50px",
                                                            height: "24px",
                                                            padding: "0px"
                                                          },
                                                          attrs: {
                                                            type: "primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.filterConfirm(
                                                                "autoUser"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("确定")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("input", {
                                                staticClass:
                                                  "btn btn-red filter-btn",
                                                attrs: {
                                                  slot: "reference",
                                                  type: "button",
                                                  value: "筛选"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.getUserFilterData(
                                                      "autoUser"
                                                    )
                                                  }
                                                },
                                                slot: "reference"
                                              })
                                            ],
                                            1
                                          ),
                                          _c("input", {
                                            staticClass:
                                              "btn btn-red export-btn",
                                            attrs: {
                                              type: "button",
                                              value: "导出"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.exportTable(
                                                  "dynamic"
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          data: _vm.dynamicUserData,
                                          height:
                                            _vm.screenHeight > 800
                                              ? "calc(100vh - 480px)"
                                              : "calc(100vh - 330px)",
                                          border: "",
                                          "tooltip-effect": "dark"
                                        }
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "userName",
                                            label: "用户",
                                            width: "250",
                                            "show-overflow-tooltip": ""
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "mngLevel",
                                            label: "职级",
                                            width: "250",
                                            "show-overflow-tooltip": ""
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "jobNames",
                                            label: "职位",
                                            "show-overflow-tooltip": ""
                                          }
                                        }),
                                        _c(
                                          "el-table-column",
                                          {
                                            attrs: {
                                              prop: "corner",
                                              "show-overflow-tooltip": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(scope) {
                                                    return [
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            placement: "top"
                                                          }
                                                        },
                                                        [
                                                          _c("div", {
                                                            attrs: {
                                                              slot: "content"
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.ToBreak(
                                                                  scope.row
                                                                    .corner +
                                                                    "角"
                                                                )
                                                              )
                                                            },
                                                            slot: "content"
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "line"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .corner
                                                                ) + "角"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              51124512
                                            )
                                          },
                                          [
                                            _c("template", { slot: "header" }, [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "header-ellipsis font14"
                                                },
                                                [_vm._v("AB角")]
                                              )
                                            ])
                                          ],
                                          2
                                        ),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "manageOrgName",
                                            label: "管辖部门",
                                            "show-overflow-tooltip": ""
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "bizLineName",
                                            label: "管辖条线",
                                            "show-overflow-tooltip": ""
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "createdTime",
                                            label: "创建时间",
                                            "show-overflow-tooltip": ""
                                          }
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "updatedTime",
                                            label: "最后更新时间",
                                            "show-overflow-tooltip": ""
                                          }
                                        }),
                                        _vm._v(" > ")
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "footer-page" },
                                      [
                                        _c("el-pagination", {
                                          attrs: {
                                            background: "",
                                            layout:
                                              "total, sizes, prev, pager, next, jumper",
                                            total: _vm.dynamicPagination.total,
                                            "current-page":
                                              _vm.dynamicPagination.pageNum,
                                            "page-sizes": [
                                              10,
                                              20,
                                              50,
                                              100,
                                              1000,
                                              2000
                                            ],
                                            "page-size":
                                              _vm.dynamicPagination.pageSize,
                                            "hide-on-single-page": false
                                          },
                                          on: {
                                            "update:currentPage": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dynamicPagination,
                                                "pageNum",
                                                $event
                                              )
                                            },
                                            "update:current-page": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dynamicPagination,
                                                "pageNum",
                                                $event
                                              )
                                            },
                                            "current-change":
                                              _vm.dynamicCurrentChange,
                                            "size-change": _vm.dynamicSizeChange
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }